(function (window, document) {
  'use strict';

  if (!window || !document) {
    return;
  }

  const ACCEPTED_QUERY_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'mkwid',
    'lead_attribution',
    'matchtype',
    'campaign_id',
    'adgroup_id',
    'creative_id',
    'keyword_id',
    'extension_id',
    'ad_network',
    'ad_position',
    'ad_placement',
    'ad_device',
    'ad_devicemodel',
    'ad_physical_location',
    'is_paid',
    'is_spanish',
    'form_id',
    'click_id',
    'audience',
    'aff_id',
    'aff_track1',
    'aff_track2',
    'aff_track3',
    'aff_track4',
    'aff_track5',
    'utm_s',
    'utm_c',
    'utm_m',
    'utm_co',
    'utm_t',
    'ad_c',
    'ca_id',
    'ag_id',
    'kw_id',
    'cr_id',
    'ex_id',
    'ad_m',
    'ad_n',
    'ad_d',
    'ad_dm',
    'ad_pos',
    'ad_pl',
    'aud',
    'l_attr',
    'is_sp',
    'adwords_campaignid',
    'adwords_adgroup',
    'adwords_creative',
    'adwords_network',
    'adwords_matchtype',
    'adwords_feeditemid',
    'adwords_adposition',
    'adwords_placement',
    'adwords_device',
    'adwords_devicemodel',
    'adwords_location',
    'campaignid',
    'adgroup',
    'creative',
    'network',
    'adposition',
    'device',
    'devicemodel',
    'gclid',
    'msclkid',
    'fbclid',
    'assist_type',
    'campaign_type',
  ];

  function getCookie(name) {
    const nameEq = name + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(nameEq) === 0) {
        return cookie.substring(nameEq.length);
      }
    }

    return '';
  }

  function getGAUserId() {
    const gaCookie = getCookie('_ga');

    if (!gaCookie) {
      return '';
    }

    const parts = gaCookie.split('.');
    return parts.length >= 4 ? parts.slice(2).join('.') : gaCookie;
  }

  function getQueryParams() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search || '');

    ACCEPTED_QUERY_PARAMS.forEach((key) => {
      const value = urlParams.get(key);

      if (value) {
        params[key] = value;
      }
    });

    return params;
  }

  function getUTMParams() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search || '');

    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
      const value = urlParams.get(key);

      if (value) {
        params[key] = value;
      }
    });

    return params;
  }

  function getGlobalParams() {
    const params = {
      js_enabled: 1,
    };

    const gaUserId = getGAUserId();
    if (gaUserId) {
      params.ga_user_id = gaUserId;
    }

    const microUserId = getCookie('mixp_id');
    if (microUserId) {
      params.micro_user_id = microUserId;
    }

    const sessionId = getCookie('mixp_session_id');
    if (sessionId) {
      params.micro_session_id = sessionId;
    }

    Object.assign(params, getUTMParams());

    return params;
  }

  window.siteTracking = window.siteTracking || {};
  window.siteTracking.getCookie = getCookie;
  window.siteTracking.getQueryParams = getQueryParams;
  window.siteTracking.getGlobalParams = getGlobalParams;
})(window, document);
